enum EErrorCode {
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  ACCESS_DENIED = 403,
  NOT_FOUND = 404,
  INTERNAL_ERROR = 500,
  INVALID_SESSION_ID = 40001,
  CANT_LOAD_SESSION = 40002,
  USER_TOKENS_MISSING = 40101,
  INVALID_BRAND = 40201,
  INVALID_MARKET = 40202,
  DISABLED_MARKET = 40203,
  SESSION_NOT_FOUND = 50001,
  INVALID_CODE = 60001,
  VEHICLE_NOT_FOUND = 60002,
  WLTP_INVALID = 60003,
  OUTDATED_VEHICLE = 60004,
  GENERAL_STREAM_ERROR = 70001,
  NO_INSTANCE_AVAILABLE = 70002,
  VEHICLE_NOT_INSTALLED = 70003,
}

const E3D_ERROR_CODE_TO_TRANSLATION_KEY: Record<EErrorCode, string> = {
  [EErrorCode.BAD_REQUEST]: 'e3d.error.badRequest',
  [EErrorCode.UNAUTHORIZED]: 'e3d.error.unauthorized',
  [EErrorCode.ACCESS_DENIED]: 'e3d.error.accessDenied',
  [EErrorCode.NOT_FOUND]: 'e3d.error.notFound',
  [EErrorCode.INTERNAL_ERROR]: 'e3d.error.internalError',
  [EErrorCode.INVALID_SESSION_ID]: 'e3d.error.invalidSessionId',
  [EErrorCode.CANT_LOAD_SESSION]: 'e3d.error.cantLoadSession',
  [EErrorCode.USER_TOKENS_MISSING]: 'e3d.error.userTokensMissing',
  [EErrorCode.INVALID_BRAND]: 'e3d.error.invalidBrand',
  [EErrorCode.INVALID_MARKET]: 'e3d.error.invalidMarket',
  [EErrorCode.DISABLED_MARKET]: 'e3d.error.disabledMarket',
  [EErrorCode.SESSION_NOT_FOUND]: 'e3d.error.sessionNotFound',
  [EErrorCode.INVALID_CODE]: 'e3d.error.invalidCode',
  [EErrorCode.VEHICLE_NOT_FOUND]: 'e3d.error.vehicleNotFound',
  [EErrorCode.WLTP_INVALID]: 'e3d.error.wltpInvalid',
  [EErrorCode.OUTDATED_VEHICLE]: 'e3d.error.outdatedVehicle',
  [EErrorCode.GENERAL_STREAM_ERROR]: 'e3d.error.generalStreamError',
  [EErrorCode.NO_INSTANCE_AVAILABLE]: 'e3d.error.noInstanceAvailable',
  [EErrorCode.VEHICLE_NOT_INSTALLED]: 'e3d.error.vehicleNotInstalled',
}

export const getE3DErrorTranslationKey = (errorCode: number): string => {
  const translationKey = E3D_ERROR_CODE_TO_TRANSLATION_KEY[errorCode as EErrorCode]
  return translationKey || 'e3d.error.unknown'
}

export const isKnownE3DErrorCode = (errorCode: number): boolean => {
  return Object.values(EErrorCode).includes(errorCode as EErrorCode)
}

export { EErrorCode }
